import {Service} from './';

export class TenantService extends Service {

  static entity: string = 'abp/multi-tenancy/tenants';

  static getByName(name: string): Promise<any> {
    return this.axios.get(`${this.entity}/by-name/${name}`).then(res => res.data);
  }

}
